<template>
  <div>
    <component v-if="loaded" :is="layout">
      <router-view/>
    </component>
    <div class="loader" v-if="loading" >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <AutoLogoutCountdown/>
    <ConfirmModal/>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/app";
</style>

<script setup>
import AutoLogoutCountdown from "@/components/parts/general/AutoLogoutCountdown.vue"
import ConfirmModal from "@/components/parts/general/ConfirmModal.vue"
import { computed, onMounted, onUnmounted } from "vue"
import { useStore } from "vuex"
import { useRoute } from "vue-router"
import { useHead } from "@unhead/vue"

const store = useStore()
const route = useRoute()

// page titles (set by the pages with useHead) get the product name; pages without a title show it alone
useHead({
  titleTemplate: (title) => title ? `${title} | Dentist+` : 'Dentist+',
})

const loaded = true

// the layout of the route, registered globally in main.js (default-layout, super_admin-layout, empty-layout)
const layout = computed(() => {
  if(!route) return 'empty-layout'
  return (route.meta.layout || "empty") + '-layout'
})

const loading = computed(() => store.state.dom.loading)

const resizeEventHandler = () => {
  store.commit('updateMobile')
}

window.addEventListener("resize", resizeEventHandler)

onMounted(() => {
  store.commit('updateMobile')
})

onUnmounted(() => {
  window.removeEventListener("resize", resizeEventHandler)
})
</script>
